import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { IBreadcrum } from './breadcrumbs/breadcrumbs.component';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbsService {
  public breadcrumbs: IBreadcrum[] = [];

  public breadcrumbsChanges = new Subject<IBreadcrum[]>();

  constructor() {
    this.breadcrumbsChanges.subscribe(
      // (breadcrumbs) => {
      //   this.breadcrumbs = breadcrumbs;
      // },
      // (error) => {
      //   console.error(error);
      // }
      // Update para RXJS 8
      {
        next: (breadcrumbs: IBreadcrum[]) => {
          this.breadcrumbs = breadcrumbs;
        },
        error: (error: any) => {
          console.error(error);
        },
      },
    );
  }

  public setBreadcrumbs(breadcrumbs: IBreadcrum[]) {
    this.breadcrumbsChanges.next(breadcrumbs);
  }

  public pushBreadcrumb(breadcrumb: IBreadcrum) {
    this.breadcrumbsChanges.next([...this.breadcrumbs, breadcrumb]);
  }
}
